import { render } from "./WCItemModifierLinkedItemsGroup.vue?vue&type=template&id=80fcb82e&scoped=true"
import script from "./WCItemModifierLinkedItemsGroup.vue?vue&type=script&lang=js"
export * from "./WCItemModifierLinkedItemsGroup.vue?vue&type=script&lang=js"

import "./WCItemModifierLinkedItemsGroup.vue?vue&type=style&index=0&id=80fcb82e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fcb82e"]])

export default __exports__